import {WidgetDatasourceEnum} from "./widget-datasource.enum";

export const DataSourceMetricColorEnum = {
  [WidgetDatasourceEnum.servicesStatusTotals]: {
    status: {
      unAssigned: 'rgb(127, 137, 140)',
      assigned: 'rgb(58, 175, 215)',
      started: 'rgb(32, 94, 169)',
      manualCompleted: 'rgb(66, 169, 65)',
      late: 'rgb(255, 107, 109)',
      packed: 'rgb(66, 169, 65)',
      notPacked: 'rgb(240, 62, 56)',
      pickedUp: 'rgb(18, 91, 186)',
      canceled: 'rgb(145, 0, 0)',
      aborted: 'rgb(213, 36, 36)',
      risk: 'rgb(255, 107, 109)',
      completed: 'rgb(49, 139, 49)'
    }
  },
  [WidgetDatasourceEnum.ordersStatusTotal]: {
    status: {
      total: 'rgb(127, 137, 140)',
      pending: 'rgb(127, 137, 140)',
      started: 'rgb(32, 94, 169)',
      completed: 'rgb(49, 139, 49)',
      canceled: 'rgb(145, 0, 0)',
      draft: 'rgb(58, 175, 215)',
      partiallyScheduled: 'rgb(66, 169, 65)',
      onHold: 'rgb(255, 107, 109)',
      pendingCompletionApproval: 'rgb(18, 91, 186)'
    }
  },
  [WidgetDatasourceEnum.ordersTotal]: {
    total: {
      count: 'rgb(127, 137, 140)',
      distance: 'rgb(127, 137, 140)',
      packages: 'rgb(32, 94, 169)',
      packedInItems: 'rgb(49, 139, 49)',
      pallets: 'rgb(145, 0, 0)',
      spots: 'rgb(58, 175, 215)',
      volume: 'rgb(66, 169, 65)',
      weight: 'rgb(255, 107, 109)'
    }
  },
  [WidgetDatasourceEnum.uniqueServiceFieldCount]: {
    serviceField: {
      accountId: 'rgb(32, 94, 169)'
    }
  },
  [WidgetDatasourceEnum.agentsStatusTotal]: {
    status: {
      onDuty: 'rgb(66, 169, 66)',
      offDuty: 'rgb(136, 147, 150)',
      onDutyOnBreak: 'rgb(248, 167, 45)'
    }
  }
}
